import { jsx as _jsx } from "react/jsx-runtime";
import "./WhatsAppButton.scss";
import { icons, URLS } from "@/utils/constants";
import { useLocation } from "react-router-dom";
export const WhatsAppButton = () => {
    const { pathname } = useLocation();
    return (!pathname.includes(URLS.checkout) && (_jsx("a", { href: "https://wa.me/573132316080", target: "_blank", rel: "noopener noreferrer", children: _jsx("img", { src: icons.WhatsApp, className: `sticky-button sticky`, alt: "WhatsApp Flormorado Caf\u00E9" }) })));
};
